import CloseIcon from '@mui/icons-material/Close';
import { Dialog, styled, Typography, TypographyProps } from '@mui/material';
import { RookeryRegularFont } from 'v3/styles/common';
import { theme } from 'v3/styles/global-styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.common.white}`,
    borderRadius: '0.375rem',
    width: '100%',
    height: 'unset',
    maxWidth: '19.5rem',
    padding: '1.5rem',
    gap: '2rem',
  },
}));

export const Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
});

export const CloseBox = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
});

export const CloseIconStyled = styled(CloseIcon)({
  cursor: 'pointer',
  color: theme.palette.common.white,
  '&:hover': {
    color: theme.palette.grey[600],
  },
});

export const SubtitleMediumStyled = styled(Typography)<TypographyProps>(() => ({
  font: `400 1rem ${RookeryRegularFont}`,
  opacity: '0.3',
  color: theme.palette.common.white,
}));
